/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {GenericObject, Link} from '@ion/core/src/types/entities';
import {FormState} from '@ion/dls/src/hooks/useFormState';

export enum BulkAddDevicesFormFields {
  DeviceIdentifierType = 'deviceIdentifierType',
  DeviceType = 'deviceType',
  DeviceConfiguration = 'deviceConfiguration',
  DeviceIdentifiers = 'deviceIdentifiers'
}

// Builds the initial form state for the Device Config form dialogs.
export const getInitialBulkAddDevicesFormState = (): FormState => ({
  [BulkAddDevicesFormFields.DeviceIdentifierType] : {
    name     : BulkAddDevicesFormFields.DeviceIdentifierType,
    required : true
  },
  [BulkAddDevicesFormFields.DeviceType] : {
    name     : BulkAddDevicesFormFields.DeviceType,
    required : true
  },
  [BulkAddDevicesFormFields.DeviceConfiguration] : {
    name     : BulkAddDevicesFormFields.DeviceConfiguration,
    required : true
  },
  [BulkAddDevicesFormFields.DeviceIdentifiers] : {
    name     : BulkAddDevicesFormFields.DeviceIdentifiers,
    required : true
  }
});

// Serializes the form state into an API-consumable Device Config
export const serialize = (
  formState: FormState,
  account: Link
): GenericObject => {
  const serialized: GenericObject = {account};
  for (const [key, {value}] of Object.entries(formState)) {
    switch (key) {
      case BulkAddDevicesFormFields.DeviceType :
      case BulkAddDevicesFormFields.DeviceConfiguration :
        serialized[key] = value?.name;
        break;
      default :
        if (value) {
          serialized[key] = value;
        }
        break;
    }
  }
  return serialized;
};
